import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Calendar, GraduationCap, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
import { Formation } from '../data/constants';
interface FormationCardProps {
  formation: Formation;
}
export function FormationCard({
  formation
}: FormationCardProps) {
  return <Card className="flex flex-col h-full shadow-lg border-none hover:-translate-y-2 hover:shadow-xl transition-all duration-500 overflow-hidden group bg-white" data-id="element-345" data-mp="2ly2hpt1lwzre">
      <div className="h-2 w-full bg-primary group-hover:bg-brand-orange transition-colors duration-500" data-id="element-346" data-mp="2v03c8i5gh7pd" />
      <CardHeader className="pt-8" data-id="element-347" data-mp="2zx21ama9iogp">
        <div className="flex flex-wrap gap-2 mb-4" data-id="element-348" data-mp="2zw0q8ht8y1yz">
          <Badge variant="default" className="bg-lavande text-primary-dark hover:bg-lavande/80 border-none font-bold" data-id="element-349" data-mp="10m2e5zhqcoqc">
            {formation.level}
          </Badge>
          <Badge variant="outline" className="text-muted-foreground border-slate-200" data-id="element-350" data-mp="2qu486t8cmvz8">
            {formation.rncp}
          </Badge>
        </div>
        <CardTitle className="text-2xl md:text-3xl leading-tight font-heading font-extrabold text-primary-dark group-hover:text-primary transition-colors" data-id="element-351" data-mp="2i093tnf1x9kn">
          {formation.title}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1 space-y-6" data-id="element-352" data-mp="39qwz4iu1nkqe">
        <p className="text-muted-foreground text-lg leading-relaxed line-clamp-3" data-id="element-353" data-mp="35qd69rgi73a2">
          {formation.description}
        </p>
        <div className="space-y-3 pt-6 border-t border-slate-100 text-base text-muted-foreground" data-id="element-354" data-mp="30qh1hpzzf7tg">
          <div className="flex items-center gap-3 group/item" data-id="element-355" data-mp="2vsypfqqo4ch8">
            <Clock className="w-5 h-5 text-brand-orange group-hover/item:animate-soft-bounce" data-id="element-356" data-mp="2vujifbxc3ncz" />
            <span className="font-medium" data-id="element-357" data-mp="1p9qqzuoiztu1">Durée : {formation.duration}</span>
          </div>
          <div className="flex items-center gap-3 group/item" data-id="element-358" data-mp="1kf3bumfewbs4">
            <Calendar className="w-5 h-5 text-brand-orange group-hover/item:animate-soft-bounce" data-id="element-359" data-mp="1lvh3vezmxiw4" />
            <span className="font-medium" data-id="element-360" data-mp="1qrz5w73kz34r">Rythme : {formation.rhythm}</span>
          </div>
          <div className="flex items-center gap-3 group/item" data-id="element-361" data-mp="1csfyxhmi9xu1">
            <GraduationCap className="w-5 h-5 text-brand-orange group-hover/item:animate-soft-bounce" data-id="element-362" data-mp="1hskjbiqjbcpj" />
            <span className="font-medium" data-id="element-363" data-mp="133y2tdp68ewq">Rentrée : {formation.rentree}</span>
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex flex-col sm:flex-row gap-4 pt-8 pb-8" data-id="element-364" data-mp="17uoaixl2ktul">
        <Button variant="outline" className="w-full text-primary-dark border-primary/20 hover:bg-primary/5 font-semibold" asChild data-id="element-365" data-mp="u39p6k3owgkd">
          <Link to={`/formations/${formation.id}`} data-id="element-366" data-mp="y2iixoyqcefx">Voir le programme</Link>
        </Button>
        <Button className="w-full group/btn bg-brand-orange hover:bg-[#E67E22] text-white font-semibold" asChild data-id="element-367" data-mp="k5lozenbegut">
          <Link to="/candidater" data-id="element-368" data-mp="5hldippgrpm8">
            Candidater
            <ArrowRight className="w-5 h-5 ml-2 group-hover/btn:translate-x-1 transition-transform" data-id="element-369" data-mp="5k7m8so3cb61" />
          </Link>
        </Button>
      </CardFooter>
    </Card>;
}